import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './PaymentResultPage.css';

export default function PaymentResultPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Определяем статус по параметрам URL
  const isSuccess = searchParams.has('success');
  const orderId = searchParams.get('id');

  // Загружаем dotlottie-player
  useEffect(() => {
    const alreadyLoaded = document.querySelector('script[data-dotlottie-player]');
    if (alreadyLoaded) return;
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/@dotlottie/player-component@latest/dist/dotlottie-player.js';
    script.async = true;
    script.setAttribute('data-dotlottie-player', 'true');
    document.head.appendChild(script);
  }, []);

  const handleGoHome = () => {
    navigate('/home');
  };

  return (
    <div className="payment-result-page">
      <div className="payment-result-content">
        <div className="payment-result-animation">
          {isSuccess ? (
            <dotlottie-player
              src="/lotties/success-orange.lottie"
              background="transparent"
              speed="1"
              autoplay
              style={{ width: '150px', height: '150px', display: 'block' }}
            />
          ) : (
            <dotlottie-player
              src="/lotties/fail.lottie"
              background="transparent"
              speed="1"
              autoplay
              style={{ width: '100px', height: '150px', display: 'block' }}
            />
          )}
        </div>

        <h1 className="payment-result-title">
          {isSuccess ? 'Оплата прошла успешно!' : 'Оплата не удалась'}
        </h1>

        <p className="payment-result-message">
          {isSuccess
            ? 'Игра добавлена в вашу библиотеку. Вы можете начать играть прямо сейчас.'
            : 'Произошла ошибка при оплате. Попробуйте ещё раз или обратитесь в поддержку.'
          }
        </p>

        {orderId && (
          <p className="payment-result-order">
            Номер заказа: {orderId}
          </p>
        )}

        <button className="payment-result-button" onClick={handleGoHome}>
          Вернуться на главную
        </button>
      </div>
    </div>
  );
}
